import i18next from 'i18next';
import * as yup from 'yup';

export const schema = yup.object().shape({
  email: yup.string().email(i18next.t('validation.invalidEmail')).required(i18next.t('validation.required.email')),
});
